import { Box } from "@mui/material";

// COMPONENTS
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

// ASSET
import HuntingZonesMap from '../assets/huntingzones.jpg';

// HUNTING ZONES
export default function HuntingZones() {
    return (
        <Box sx={{ height: '100vh', overflowX: 'hidden', overflowY: 'scroll' }}>
            <Navbar />

            {/* MAIN BODY */}
            <Box component="main" sx={{ height: { xs: '100vh', md: '150vh' }, px: 5, pb: 2 }}>
                <Box display="flex" justifyContent="center" sx={{ mt: 5 }}>
                    <Box sx={{ width: { xs: '90vmin', md: '140vmin' }, p: 1, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                        <img
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            src={HuntingZonesMap}
                            alt="hunting zones map"
                            draggable="false"
                            loading="lazy"
                        />
                    </Box>
                </Box>
            </Box>

            <div style={{position: "absolute", bottom: 0}}>
                {/* FOOTER */}
                <Footer />
            </div>
            
        </Box>
    )
}
